{
  "__localization_test_string": "আপনি {{time_period}} এর জন্য এই প্রদানকারীর সর্বাধিক পরিদর্শনে পৌঁছেছেন৷ আপনি পরবর্তীতে {{start_date}} থেকে শুরু করে এই প্রদানকারীতে যেতে পারেন।.",
  "app_name": "Plentiful",
  "app_button_ok": "ঠিক আছে",
  "app_button_cancel": "বাতিল করুন",
  "app_button_yes": "হ্যাঁ",
  "app_button_no": "না",
  "app_button_confirm": "নিশ্চিত করুন",
  "app_button_try_again": "আবার চেষ্টা কর",
  "rate_the_app": "Plentiful রেট করুন",
  "app_textview_somethingwentwrong": "কিছু একটা সমস্যা হয়েছে!\nদয়া করে আবার চেষ্টা করুন।",
  "app_button_logout": "প্রস্থান",
  "app_today": "আজ",
  "app_dialog_clarify_prompt": "তুমি কি নিশ্চিত?",
  "app_personal_edittext_phone": "ফোন নম্বর",
  "app_personal_edittext_dob": "জন্ম তারিখ (ঐচ্ছিক)",
  "app_personal_edittext_firstname": "নামের প্রথম অংশ",
  "app_personal_edittext_lastname": "নামের শেষাংশ",
  "app_personal_edittext_zipcode": "জিপ কোড",
  "app_pantrykind_food": "খাদ্য ভাঁড়ারঘর",
  "app_servicekind_reservations": "রিজার্ভেশন",
  "app_servicekind_line": "লাইন",
  "distribution_schedule": "বিতরণ সময়সূচী",
  "service_type_no_digital_options": "শুধুমাত্র লাইন",
  "service_type_reservation_inline": "রিজার্ভেশন",
  "service_type_allows_pre_registration": "পূর্ব-নিবন্ধন অনুমোদিত",
  "app_locationnotavailable": "অবস্থান উপলব্ধ নেই",
  "app_generalerror": "ত্রুটি",
  "app_dialog_loading": "লোড হচ্ছে। অনুগ্রহপূর্বক অপেক্ষা করুন…",
  "app_dialog_sms_code_title": "এসএমএস কোড",
  "app_dialog_sms_code_button_send_new_code": "একটি নতুন কোড পাঠান",
  "app_release_id": "অ্যাপ্লিকেশন রিলিজ শনাক্তকারী",
  "sms_disclaimer": "বার্তা এবং ডেটা চার্জ প্রযোজ্য হতে পারে। বন্ধ করতে STOP লিখে পাঠান।",
  "fragment_registration_language_textview_title": "শুরু করতে আপনার পছন্দের ভাষা নির্বাচন করুন",
  "fragment_registration_language_button_next": "পরবর্তী",
  "fragment_registration_family_textview_title": "আপনার পরিবার সম্পর্কে আমাদের বলুন",
  "fragment_registration_family_textview_adults": "প্রাপ্তবয়স্কদের সংখ্যা (18-{{senior_age_threshold_minus_one}})",
  "fragment_registration_family_textview_children": "শিশুদের সংখ্যা (18 বছরের কম)",
  "fragment_registration_family_textview_seniors": "বয়স্কদের সংখ্যা ({{senior_age_threshold}}+)",
  "fragment_registration_family_textview_notetitle": "বিঃদ্রঃ:",
  "fragment_registration_family_textview_notecontent": "আপনার পরিবারের বিস্তারিত তথ্য প্রদান করে আপনাকে আরও ভালোভাবে সেবা প্রদানে আমাদের সহায়তা করুন। অনুগ্রহ করে মনে রাখবেন: উপরে তালিকাভুক্ত পরিবারের সদস্যদের মধ্যে নিজেকে অন্তর্ভুক্ত করবেন না।",
  "fragment_registration_family_button_back": "পেছনে",
  "fragment_registration_family_button_next": "পরবর্তী",
  "fragment_registration_personal_textview_title": "আপনার প্লান্টিফুল প্রোফাইলে স্বাগতম।",
  "fragment_registration_personal_button_back": "পেছনে",
  "fragment_registration_personal_button_finish": "শেষ পর্যন্ত",
  "fragment_main_tabitem_pantrymap": "মানচিত্র",
  "fragment_main_tabitem_pantrylist": "তালিকা",
  "fragment_main_bottombar_pantries": "Pantries.",
  "fragment_main_bottombar_visits": "পরিদর্শন",
  "fragment_main_bottombar_messages": "বার্তা",
  "fragment_main_bottombar_profile": "প্রোফাইল",
  "cell_pantry_short_visit_date": "আপনি যাচ্ছেন",
  "fragment_pantrydetail_button_changetime": "সময় পরিবর্তন করুন",
  "fragment_pantrydetail_textview_amenities": "সতর্কতা",
  "fragment_pantrydetail_textview_conditions": "শর্তাবলী",
  "fragment_pantrydetail_textview_notes": "প্যান্ট্রি নোট",
  "fragment_pantrydetail_edittext_message": "বার্তা ...",
  "fragment_pantrydetail_button_createreservation": "সফরের সময়সূচী",
  "fragment_pantrydetail_button_schedulevisit": "সফরের সময়সূচী",
  "dialog_visittime_textview_nodatesavailable": "কোন তারিখ উপলব্ধ",
  "fragment_visitlist_textview_title": "পরিদর্শন",
  "fragment_visitlist_textview_zero": "এই যেখানে আপনি আপনার আসন্ন সেবা বার পরিচালনা করতে পারেন। একটি দর্শন সময়সূচী একটি pantry খুঁজুন!",
  "fragment_messagethreadlist_textview_title": "বার্তা",
  "fragment_messagethreadlist_textview_zero": "এখনও কোনও আপডেট নেই!\nআপডেটগুলিতে সাবস্ক্রাইব করতে, আপনার প্রিয় প্যান্ট্রির বিশদ পৃষ্ঠায় যান এবং পৃষ্ঠার নীচের অংশে 'এই প্যান্ট্রি থেকে আপডেট পান' টগল করুন।",
  "fragment_profile_textview_title": "প্রোফাইল",
  "fragment_profile_button_savechanges": "পরিবর্তনগুলোর সংরক্ষন",
  "fragment_profile_textview_personaldetails": "ব্যক্তিগত বিবরণ",
  "fragment_profile_textview_language": "ভাষা",
  "fragment_profile_textview_notifications": "বিজ্ঞপ্তি",
  "fragment_profile_switch_receivenotifications": "পুশ নোটিফিকেশন",
  "receive_notifications_helper": "আপনার ডিভাইসে সতর্কতা পান",
  "fragment_profile_textview_servicedetails": "সেবা বিবরণ",
  "fragment_profile_switch_pickupfood": "আমার খাবার অন্য কাউকে তুলে দিতে হবে।",
  "fragment_profile_edittext_pickupname": "পিকআপ প্রতিনিধি প্রথম এবং শেষ নাম",
  "fragment_profile_edittext_pickupphone": "পিকআপ প্রতিনিধির ফোন নম্বর",
  "textview_baby_supplies": "কত শিশুর জন্য আপনার শিশুর সরবরাহ প্রয়োজন (ডায়পার, ওয়াইপস, সূত্র)",
  "fragment_profile_textview_emergencycontact": "জরুরী যোগাযোগ",
  "fragment_profile_edittext_emergencyname": "জরুরী যোগাযোগ প্রথম এবং শেষ নাম",
  "fragment_profile_edittext_emergencyphone": "জরুরী যোগাযোগের ফোন",
  "aiq_validation_error_regex_telephone_us": "ফোন নম্বরটি ভুল ফরম্যাটের",
  "fragment_profile_textview_changepersonalinfo": "এই তথ্য কোন plentiful খাদ্য pantry এ আপডেট করা যেতে পারে।",
  "fragment_profile_edittext_feedback": "প্রতিক্রিয়া ...",
  "fragment_profile_toast_feedbacksent": "প্রতিক্রিয়া পাঠানো",
  "baby_supplies": "শিশুর সরবরাহ",
  "household_size": "পরিবারের আকার",
  "food_pickup": "খাবার পিকআপ",
  "emergency_contact": "জরুরী যোগাযোগ",
  "dialog_app_update_title": "আপডেট আপডেট করুন",
  "dialog_app_update_message": "অ্যাপের পরবর্তী সংস্করণটি Google Play Store এ উপলব্ধ!",
  "dialog_app_update_button_openplaystore": "খোলা প্লে স্টোর",
  "app_invalid_error": "অবৈধ",
  "no_pantries_available": "কোন ফলাফল পাওয়া যায়নি। অন্য কোন প্যান্ট্রির নাম দিয়ে অনুসন্ধান করার চেষ্টা করুন অথবা অনুসন্ধান বাক্সটি সাফ করুন এবং প্রচুর প্যান্ট্রি সহ এলাকাগুলি অন্বেষণ করতে মানচিত্রটি সরান বা জুম করুন।",
  "visit_served": "পরিবেশিত",
  "visit_not_served": "পরিবেশন করা হয় না",
  "visit_no_show": "আপনি প্রদর্শন না",
  "visit_group": "আপনি গ্রুপে আছেন {{group_number}}, {{time}}এর মাধ্যমে আসুন",
  "visit_pre_registered": "আপনি প্রাক-নিবন্ধিত, {{from_time}} - {{end_time}}এর মধ্যে লাইনে যোগ দিন",
  "pick_visit_time": "সময় দেখুন",
  "received_service_on": "আপনি পরিদর্শন করেছেন",
  "service_starts_at": "সেবা শুরু হয়",
  "cancel_visit": "পরিদর্শন বাতিল করুন",
  "confirm_cancel_visit": "আপনি কি আপনার পরিদর্শন বাতিল করতে চান?",
  "yes_cancel": "হ্যাঁ, বাতিল করুন",
  "send": "পাঠান",
  "reservations_available": "আমি যখন একটি ভিজিট নির্ধারণ করতে পারব তখন আমাকে জানান",
  "service_notification_error": "আপনার বিজ্ঞপ্তি পছন্দ আপডেট করতে সমস্যা হয়েছে। আবার চেষ্টা করুন। এখনও সমস্যা হচ্ছে? সহায়তার জন্য Profile তারপর We're Here to Help চাপুন।",
  "report_location_issue": "এই অবস্থানের সাথে একটি সমস্যা রিপোর্ট করুন",
  "registration_intro": "Plentiful-এ স্বাগতম! আপনার কাছাকাছি খাবারের দোকান খুঁজে পেতে আমরা আপনাকে সাহায্য করতে এখানে আছি।",
  "app_personal_edittext_enter_phone": "আপনার ফোন নম্বর লিখুন",
  "code_sent_to": "একটি এসএমএস লগইন কোড পাঠানো হয়েছে",
  "account_created": "অ্যাকাউন্ট তৈরি হয়েছে",
  "get_started": "চল শুরু করি!",
  "additional_details": "অতিরিক্ত তথ্য",
  "your_qr_code": "আপনার plenti-pass",
  "id_number": "আইডি নাম্বার",
  "personal_details_extra": "ব্যক্তিগত তথ্য এবং পছন্দ",
  "settings": "সেটিংস",
  "settings_extra": "ভাষা এবং বিজ্ঞপ্তি সেটিংস",
  "not_verified": "এখনো যাচাই না",
  "must_be_reverified_by": "দ্বারা সম্মান করা আবশ্যক",
  "last_verified_on": "শেষ সময় যাচাই",
  "at": "এ",
  "no_visit_options_available": "এই মুহুর্তে আপনার জন্য কোন পরিদর্শন বিকল্প উপলব্ধ নেই। প্যান্ট্রি শর্ত চেক করুন বা প্যান্ট্রি যোগাযোগ করুন.",
  "need_help": "সাহায্য দরকার?",
  "email": "ইমেইল.",
  "terms_conditions": "শেষ ব্যবহারকারী চুক্তি",
  "privacy_policy": "গোপনীয়তা নীতি",
  "updates": "আপডেট",
  "family_details": "পরিবারের বিবরণ",
  "welcome_to_plentiful": "প্রচুর পরিমাণে স্বাগতম!",
  "enter_email_phone": "সাইন আপ করলে আপনি রিজার্ভেশন করতে পারবেন এবং আপনার পরিদর্শন করা খাবারের প্যান্ট্রিগুলির আপডেট পেতে পারবেন।\nযদি আপনি কোনও খাবারের প্যান্ট্রিতে নিবন্ধিত হয়ে থাকেন, তাহলে সেই একই ফোন নম্বর বা ইমেল ব্যবহার করুন। \nসাহায্যের প্রয়োজন? support@plentiful.org এ আমাদের সাথে যোগাযোগ করুন।",
  "email_or_phone": "মোবাইল নম্বর অথবা ইমেল ঠিকানা",
  "email_address": "ইমেইল ঠিকানা",
  "enter_email": "তুমার ইমেইল প্রবেশ করাও",
  "address": "ঠিকানা",
  "email_invalid": "ইমেইল ঠিকানা বৈধ নয়",
  "no_sms_enabled_phone": "ফোন নম্বর পাঠ্য বার্তা গ্রহণ করতে পারে না",
  "verification_email_sent": "যাচাইকরণ ইমেইল পাঠানো!",
  "check_verification_email": "আপনার ইমেল চেক করুন এবং আপনার অ্যাকাউন্ট যাচাই করতে ভিতরের বোতামে ক্লিক করুন",
  "email_verification_sent": "আমরা আপনাকে একটি ইমেল পাঠিয়েছি। আপনার ইমেল ঠিকানা যাচাই করতে ইমেলের বোতামে ক্লিক করুন।.",
  "email_address_purpose": "Plentiful থেকে পরিদর্শন অনুস্মারক এবং গুরুত্বপূর্ণ আপডেট পেতে",
  "sign_up": "নিবন্ধন করুন",
  "sign_in": "সাইন ইন করুন",
  "continue": "চালিয়ে যান",
  "create_password": "গুপ্ত সংকেত সৃষ্টি করুন",
  "enter_password": "সাইন ইন করার জন্য আপনার পাসওয়ার্ড লিখুন দয়া করে",
  "password_info_box": "আপনি যদি আপনার পাসওয়ার্ড ভুলে গিয়ে থাকেন বা আপনি পাসওয়ার্ড সেট না করেই একটি প্যান্ট্রিতে নিবন্ধিত হয়ে থাকেন, তাহলে একটি ম্যাজিক দিয়ে লগ ইন করতে বা আপনার পাসওয়ার্ড পুনরায় সেট করতে দয়া করে নীচের বিকল্পগুলি ব্যবহার করুন৷.",
  "reset_password": "পাসওয়ার্ড রিসেট করুন",
  "password": "পাসওয়ার্ড",
  "eight_characters": "অন্তত 8 অক্ষর",
  "one_special_character": "অন্তত 1 বিশেষ চরিত্র",
  "one_number": "অন্তত একটি সংখ্যা",
  "submit": "জমা দিন",
  "send_magic_link": "ম্যাজিক লিঙ্ক পাঠান",
  "magic_link_sent": "আপনার ইনবক্সে একটি ম্যাজিক লিংক এসেছে।",
  "confirm_magic_link_login": "ম্যাজিক লিঙ্ক লগইন নিশ্চিত করুন",
  "sign_in_another_way": "অন্য উপায় সাইন ইন করুন",
  "enter_phone": "অনুগ্রহ করে আপনার ফোন নাম্বারটি প্রদান করুন",
  "skip": "বাদ দিন",
  "optional": "ঐচ্ছিক",
  "enter_activation_code": "আপনার লগইন কোড লিখুন",
  "activation_code": "লগইন কোড",
  "accept_eula": "আমি ব্যবহার এবং গোপনীয়তা শর্তাবলী পড়া এবং সম্মত হয়েছে",
  "email_verified": "ইমেইল যাচাই",
  "email_verified_details": "আপনার ইমেইল ঠিকানা এখন যাচাই করা হয়।",
  "do_not_ask_again": "আবার জিজ্ঞাসা করবেন না.",
  "email_in_use": "আমরা ইতিমধ্যে এই ইমেইল সঙ্গে যুক্ত একটি অ্যাকাউন্ট আছে। একটি ভিন্ন ইমেইল ব্যবহার করুন",
  "reset_password_text": "আপনার পাসওয়ার্ড রিসেট করার জন্য আপনার ইমেইল লিখুন দয়া করে",
  "reset_password_sent": "পাসওয়ার্ড ইমেইল পাঠানো রিসেট করুন!",
  "reset_password_sent_text": "যদি আমাদের {{email}} এর জন্য ফাইলটিতে একটি অ্যাকাউন্ট থাকে তবে আমরা আপনার পাসওয়ার্ডটি রিসেট করার জন্য একটি লিঙ্ক পাঠিয়েছি,",
  "dob_required": "জন্ম তারিখ",
  "please_verify": "আপনার প্রোফাইলে ফোন বা ইমেল যাচাই করুন",
  "open_profile": "খুলুন প্রোফাইল",
  "send_another_verification_email": "অন্য যাচাইকরণ ইমেইল পাঠান",
  "need_to_change_email": "আপনি যদি আপনার ইমেল ঠিকানা পরিবর্তন করতে চান, অনুগ্রহ করে support@plentifulapp.com এ যোগাযোগ করুন।",
  "need_to_change_email_or_phone": "আপনি যদি আপনার ইমেল ঠিকানা বা ফোন নম্বর পরিবর্তন করতে চান, তাহলে অনুগ্রহ করে support@plentifulapp.com এ যোগাযোগ করুন।",
  "need_to_change_phone": "আপনি যদি আপনার ফোন নম্বরটি পরিবর্তন করতে চান তবে দয়া করে support@plentifulapp.com এ যোগাযোগ করুন অথবা একটি প্যান্ট্রি পরিদর্শন করুন।.",
  "email_subscription": "ইমেল সাবস্ক্রিপশন",
  "email_subscribed": "ইমেল সাবস্ক্রাইব",
  "email_unsubscribed": "ইমেল unsubscribed",
  "email_subscribed_text": "আপনি এখন {{email}} সাবস্ক্রিপশনযুক্ত ইমেলগুলিতে সাবস্ক্রাইব করেছেন",
  "email_unsubscribed_text": "আপনি এখন প্রচুর ইমেল থেকে {{ইমেল}} unsubscribed আছে",
  "here_to_subscribe": "প্রচুর ইমেইল সাবস্ক্রাইব করতে এখানে ক্লিক করুন",
  "here_to_unsubscribe": "প্রচুর ইমেইল থেকে সদস্যতা ত্যাগ করতে এখানে ক্লিক করুন",
  "unsubscribe": "আনসাবস্ক্রাইব করুন",
  "subscribe": "সাবস্ক্রাইব",
  "open_profile_text": "আপনার প্রোফাইলে যেতে এখানে ক্লিক করুন",
  "sign_in_text": "সাইন ইন করতে এখানে ক্লিক করুন",
  "phone_assigned": "এই ফোন নম্বর ইতিমধ্যে ব্যবহার করা হয়। অন্য ফোন নম্বর লিখুন বা ফিরে যান এবং পরিবর্তে এই ফোন নম্বর দিয়ে সাইন ইন করুন।",
  "email_subscribe": "ইমেল আপডেট",
  "email_subscribe_helper": "আপনি যে প্যান্ট্রি পরিদর্শন করেন এবং Plentiful থেকে ইমেল",
  "message_preferences": "বার্তা পছন্দসমূহ",
  "message_preferences_description": "আপনি কিভাবে ভিজিট রিমাইন্ডার এবং আপডেট পেতে চান?",
  "message_method_option_0": "ইমেল এবং অ্যাপ নোটিফিকেশন",
  "message_method_option_1": "এসএমএস পছন্দ করুন",
  "message_method_helper_add_phone": "এসএমএস বার্তা পেতে আপনার ফোন নম্বর যোগ করুন",
  "message_method_helper_sms_opt_in": "এসএমএসে পুনরায় যোগ দিতে PANTRY (726-879) এ 'START' পাঠান",
  "message_method_helper_add_email": "ইমেল বার্তা পেতে আপনার ইমেল যোগ করুন",
  "message_method_helper_email_unsub": "আপনি ইমেল থেকে সদস্যতা বাতিল করেছেন। ইমেল পেতে আপনার পছন্দ আপডেট করুন।",
  "message_method_helper_add_push": "পুশ বিজ্ঞপ্তি পেতে মোবাইল অ্যাপ ডাউনলোড করুন",
  "message_method_helper_enable_push": "পুশ নোটিফিকেশন পেতে আপনার ডিভাইস সেটিংসে নোটিফিকেশন সক্ষম করুন",
  "password_error": "ভুল গোপন নম্বর. আবার চেষ্টা করুন, আপনার পাসওয়ার্ড পুনরায় সেট করুন, অথবা অন্য উপায়ে সাইন ইন করুন",
  "action_required": "কর্ম প্রয়োজন",
  "otp_error": "কোড যাচাই করা যাবে না",
  "show_more": "আরো দেখুন",
  "pre_registration": "নিবন্ধন",
  "show_less": "প্রদর্শন কম",
  "reschedule": "Reschedule.",
  "view_pantry": "প্যান্ট্রির বিবরণ দেখুন",
  "next_service_on": "পরবর্তী সেবা",
  "add_birthday": "আপনার প্লেন্টি-পাস আনলক করতে আপনার জন্মদিন যোগ করুন",
  "birthday_required": "এই পাসটি প্যান্ট্রিগুলিতে দ্রুত এবং সহজে চেক-ইন করার জন্য ব্যবহার করা যেতে পারে।",
  "missed_reservation_on": "আপনি আপনার রিজার্ভেশন মিস",
  "delete_account": "হিসাব মুছে ফেলা",
  "delete_explain": "আপনি আপনার অ্যাকাউন্ট মুছে ফেলতে চান আপনি কি নিশ্চিত? এটি সমস্ত আসন্ন প্যান্ট্রি ভিজিট বাতিল করবে এবং আপনার অ্যাকাউন্ট মুছে ফেলবে। Plentiful ব্যবহার করার জন্য আপনাকে আবার নিবন্ধন করতে হবে।",
  "yes_delete": "হ্যাঁ, মুছে দিন",
  "no_cancel": "না, বাতিল করুন",
  "select_visit_reschedule": "আপনি reschedule করতে চান পরিদর্শন নির্বাচন করুন",
  "select_visit_cancel": "আপনি বাতিল করতে চান পরিদর্শন নির্বাচন করুন",
  "search_pantries": "অনুসন্ধান pantries",
  "please_sign_in_or_up": "আপনি চালিয়ে যেতে একটি plentiful অ্যাকাউন্ট প্রয়োজন হবে। প্রচুর পরিমাণে ব্যবহার করার জন্য সম্পূর্ণ বিনামূল্যে।",
  "sign_in_or_up": "লগ ইন অথবা অবিরত করতে সাইন আপ করুন",
  "country_of_birth_option_AF": "আফগানিস্তান",
  "country_of_birth_option_AX": "এল্যান্ড দ্বীপপুঞ্জ",
  "country_of_birth_option_AL": "আলবেনিয়া",
  "country_of_birth_option_DZ": "আলজেরিয়া",
  "country_of_birth_option_AS": "আমেরিকান সামোয়া",
  "country_of_birth_option_AD": "আন্ডোরা",
  "country_of_birth_option_AO": "অ্যাঙ্গোলা",
  "country_of_birth_option_AI": "অ্যাঙ্গুইলা",
  "country_of_birth_option_AQ": "অ্যান্টার্কটিকা",
  "country_of_birth_option_AG": "অ্যান্টিগুয়া ও বার্বুডা",
  "country_of_birth_option_AR": "আর্জেন্টিনা",
  "country_of_birth_option_AM": "আর্মেনিয়া",
  "country_of_birth_option_AW": "আরুবা",
  "country_of_birth_option_AU": "অস্ট্রেলিয়া",
  "country_of_birth_option_AT": "অস্ট্রিয়া",
  "country_of_birth_option_AZ": "আজারবাইজান",
  "country_of_birth_option_BS": "বাহামা",
  "country_of_birth_option_BH": "বাহরাইন",
  "country_of_birth_option_BD": "বাংলাদেশ.",
  "country_of_birth_option_BB": "বার্বাডোস",
  "country_of_birth_option_BY": "বেলারুশ",
  "country_of_birth_option_BE": "বেলজিয়াম",
  "country_of_birth_option_BZ": "বেলিজ",
  "country_of_birth_option_BJ": "বেনিন",
  "country_of_birth_option_BM": "বারমুডা",
  "country_of_birth_option_BT": "ভুটান",
  "country_of_birth_option_BO": "বলিভিয়া",
  "country_of_birth_option_BA": "বসনিয়া ও হার্জেগোভিনা",
  "country_of_birth_option_BW": "বোতসওয়ানা",
  "country_of_birth_option_BV": "Bouvet দ্বীপ",
  "country_of_birth_option_BR": "ব্রাজিল",
  "country_of_birth_option_IO": "ব্রিটিশ ভারত মহাসাগর অঞ্চল",
  "country_of_birth_option_BN": "ব্রুনাই দারুসসালাম",
  "country_of_birth_option_BG": "বুলগেরিয়া",
  "country_of_birth_option_BF": "বুর্কিনা ফাসো",
  "country_of_birth_option_BI": "বুরুন্ডি",
  "country_of_birth_option_KH": "কম্বোডিয়া",
  "country_of_birth_option_CM": "ক্যামেরুন",
  "country_of_birth_option_CA": "কানাডা",
  "country_of_birth_option_CV": "কেপ ভার্দে",
  "country_of_birth_option_KY": "কেম্যান দ্বীপপুঞ্জ",
  "country_of_birth_option_CF": "মধ্য আফ্রিকান প্রজাতন্ত্র",
  "country_of_birth_option_TD": "চাদ",
  "country_of_birth_option_CL": "চিলি",
  "country_of_birth_option_CN": "চীন",
  "country_of_birth_option_CX": "ক্রিস্টমাস দ্বীপ",
  "country_of_birth_option_CC": "কোকোস (কিলিং) দ্বীপপুঞ্জ",
  "country_of_birth_option_CO": "কলোমবিয়া",
  "country_of_birth_option_KM": "Comoros.",
  "country_of_birth_option_CG": "কঙ্গো",
  "country_of_birth_option_CD": "কঙ্গো, গণতান্ত্রিক প্রজাতন্ত্র",
  "country_of_birth_option_CK": "কুক দ্বীপপুঞ্জ",
  "country_of_birth_option_CR": "কোস্টারিকা",
  "country_of_birth_option_CI": "কোট ডি 'আইভোর",
  "country_of_birth_option_HR": "ক্রোয়েশিয়া",
  "country_of_birth_option_CU": "কিউবা",
  "country_of_birth_option_CY": "সাইপ্রাস",
  "country_of_birth_option_CZ": "চেক প্রজাতন্ত্র",
  "country_of_birth_option_DK": "ডেনমার্ক",
  "country_of_birth_option_DJ": "জিবুতি",
  "country_of_birth_option_DM": "ডোমিনিকা",
  "country_of_birth_option_DO": "ডোমিনিকান প্রজাতন্ত্র",
  "country_of_birth_option_EC": "ইকুয়েডর",
  "country_of_birth_option_EG": "মিশর",
  "country_of_birth_option_SV": "এল সালভাদর",
  "country_of_birth_option_GQ": "নিরক্ষীয় গিনি",
  "country_of_birth_option_ER": "ইরিত্রিয়া",
  "country_of_birth_option_EE": "এস্তোনিয়া",
  "country_of_birth_option_ET": "ইথিওপিয়া",
  "country_of_birth_option_FK": "ফকল্যান্ড দ্বীপপুঞ্জ (মালভিনাস)",
  "country_of_birth_option_FO": "ফারো দ্বীপপুঞ্জ",
  "country_of_birth_option_FJ": "ফিজি",
  "country_of_birth_option_FI": "ফিনল্যান্ড",
  "country_of_birth_option_FR": "ফ্রান্স",
  "country_of_birth_option_GF": "একটি দেশের নাম",
  "country_of_birth_option_PF": "ফরাসি পলিনেশিয়া",
  "country_of_birth_option_TF": "ফরাসি সাউদার্ন টেরিটোরিজ",
  "country_of_birth_option_GA": "Gabon.",
  "country_of_birth_option_GM": "গাম্বিয়া",
  "country_of_birth_option_GE": "জর্জিয়া",
  "country_of_birth_option_DE": "জার্মানি",
  "country_of_birth_option_GH": "ঘানা",
  "country_of_birth_option_GI": "জিব্রাল্টার",
  "country_of_birth_option_GR": "গ্রীস",
  "country_of_birth_option_GL": "গ্রিনল্যান্ড",
  "country_of_birth_option_GD": "গ্রেনাডা",
  "country_of_birth_option_GP": "গুয়াডেলোপ",
  "country_of_birth_option_GU": "গুয়াম",
  "country_of_birth_option_GT": "গুয়াতেমালা",
  "country_of_birth_option_GG": "Guernsey.",
  "country_of_birth_option_GN": "গিনি",
  "country_of_birth_option_GW": "গিনি-বিসাউ",
  "country_of_birth_option_GY": "গিয়ানা",
  "country_of_birth_option_HT": "হাইতি",
  "country_of_birth_option_HM": "হেড আইল্যান্ড এবং ম্যাকডোনাল্ড দ্বীপপুঞ্জ",
  "country_of_birth_option_VA": "পবিত্র দেখুন (ভ্যাটিকান সিটি স্টেট)",
  "country_of_birth_option_HN": "হন্ডুরাস",
  "country_of_birth_option_HK": "হংকং",
  "country_of_birth_option_HU": "হাঙ্গেরি",
  "country_of_birth_option_IS": "আইসল্যান্ড",
  "country_of_birth_option_IN": "ভারত",
  "country_of_birth_option_ID": "ইন্দোনেশিয়া",
  "country_of_birth_option_IR": "ইরান (ইসলামি প্রজাতন্ত্র",
  "country_of_birth_option_IQ": "ইরাক",
  "country_of_birth_option_IE": "আয়ারল্যান্ড",
  "country_of_birth_option_IM": "আইল অফ ম্যান",
  "country_of_birth_option_IL": "ইজরায়েল",
  "country_of_birth_option_IT": "ইতালি",
  "country_of_birth_option_JM": "জামাইকা",
  "country_of_birth_option_JP": "জাপান",
  "country_of_birth_option_JE": "জার্সি",
  "country_of_birth_option_JO": "জর্ডান",
  "country_of_birth_option_KZ": "কাজাখস্তান",
  "country_of_birth_option_KE": "কেনিয়া",
  "country_of_birth_option_KI": "কিরিবাটি",
  "country_of_birth_option_KP": "কোরিয়া, গণতান্ত্রিক জনগণের প্রজাতন্ত্র",
  "country_of_birth_option_KR": "কোরিয়া, প্রজাতন্ত্র",
  "country_of_birth_option_KW": "কুয়েত",
  "country_of_birth_option_KG": "কিরগিজস্তান",
  "country_of_birth_option_LA": "লাও জনগণের গণতান্ত্রিক প্রজাতন্ত্র",
  "country_of_birth_option_LV": "লাতভিয়া",
  "country_of_birth_option_LB": "লেবানন",
  "country_of_birth_option_LS": "লেসোথো",
  "country_of_birth_option_LR": "লাইবেরিয়া",
  "country_of_birth_option_LY": "লিবিয়ান আরব জামাহিরিয়া",
  "country_of_birth_option_LI": "Liechtenstein.",
  "country_of_birth_option_LT": "লিথুয়ানিয়া",
  "country_of_birth_option_LU": "লাক্সেমবার্গ",
  "country_of_birth_option_MO": "ম্যাকাও",
  "country_of_birth_option_MK": "ম্যাসেডোনিয়া, সাবেক যুগোস্লাভ প্রজাতন্ত্র",
  "country_of_birth_option_MG": "মাদাগাস্কার",
  "country_of_birth_option_MW": "মালাউই",
  "country_of_birth_option_MY": "মালয়েশিয়া",
  "country_of_birth_option_MV": "মালদ্বীপ",
  "country_of_birth_option_ML": "মালি",
  "country_of_birth_option_MT": "মাল্টা",
  "country_of_birth_option_MH": "মার্শাল দ্বীপপুঞ্জ",
  "country_of_birth_option_MQ": "মার্টিনিক",
  "country_of_birth_option_MR": "মৌরিতানিয়া",
  "country_of_birth_option_MU": "মরিশাসাস",
  "country_of_birth_option_YT": "Mayotte.",
  "country_of_birth_option_MX": "মেক্সিকো",
  "country_of_birth_option_FM": "মাইক্রোনেশিয়া, ফেডারেটেড স্টেটস",
  "country_of_birth_option_MD": "মোল্দাভিয়া, প্রজাতন্ত্রের",
  "country_of_birth_option_MC": "মোনাকো",
  "country_of_birth_option_MN": "মঙ্গোলিয়া",
  "country_of_birth_option_MS": "মন্টসেরাট",
  "country_of_birth_option_MA": "মরক্কো",
  "country_of_birth_option_MZ": "মোজাম্বিক",
  "country_of_birth_option_MM": "মায়ানমার",
  "country_of_birth_option_NA": "নামিবিয়া",
  "country_of_birth_option_NR": "নাউরু",
  "country_of_birth_option_NP": "নেপাল",
  "country_of_birth_option_NL": "নেদারল্যান্ডস",
  "country_of_birth_option_AN": "নেদারল্যান্ডস এন্টিলস",
  "country_of_birth_option_NC": "নতুন ক্যালেডোনিয়া",
  "country_of_birth_option_NZ": "নিউজিল্যান্ড",
  "country_of_birth_option_NI": "নিকারাগুয়া",
  "country_of_birth_option_NE": "নাইজার",
  "country_of_birth_option_NG": "নাইজেরিয়া",
  "country_of_birth_option_NU": "Niue.",
  "country_of_birth_option_NF": "নরফোক দ্বীপ",
  "country_of_birth_option_MP": "উত্তর মারিয়ানা দ্বীপপুঞ্জ",
  "country_of_birth_option_NO": "নরওয়ে",
  "country_of_birth_option_OM": "ওমান",
  "country_of_birth_option_PK": "পাকিস্তান",
  "country_of_birth_option_PW": "পালাউ",
  "country_of_birth_option_PS": "ফিলিস্তিনি অঞ্চল, দখল",
  "country_of_birth_option_PA": "পানামা",
  "country_of_birth_option_PG": "পাপুয়া নিউ গিনি",
  "country_of_birth_option_PY": "প্যারাগুয়ে",
  "country_of_birth_option_PE": "পেরু",
  "country_of_birth_option_PH": "ফিলিপিন্স",
  "country_of_birth_option_PN": "Pitcairn.",
  "country_of_birth_option_PL": "পোল্যান্ড",
  "country_of_birth_option_PT": "পর্তুগাল",
  "country_of_birth_option_PR": "পুয়ের্তো রিকো",
  "country_of_birth_option_QA": "কাতার",
  "country_of_birth_option_RE": "পুনর্মিলন",
  "country_of_birth_option_RO": "রোমানিয়া",
  "country_of_birth_option_RU": "রাশিয়ান",
  "country_of_birth_option_RW": "রুয়ান্ডা",
  "country_of_birth_option_SH": "সেন্ট হেলেনা",
  "country_of_birth_option_KN": "সেন্ট কিটস ও নেভিস",
  "country_of_birth_option_LC": "সেন্ট লুসিয়া",
  "country_of_birth_option_PM": "সেন্ট পিয়ের এবং মিকেলন",
  "country_of_birth_option_VC": "সেন্ট ভিনসেন্ট ও গ্রেনাডাইন দ্বীপপুঞ্জ",
  "country_of_birth_option_WS": "সামোয়া",
  "country_of_birth_option_SM": "সান মারিনো",
  "country_of_birth_option_ST": "সাও টোমে এবং প্রিনসিপে",
  "country_of_birth_option_SA": "সৌদি আরব",
  "country_of_birth_option_SN": "সেনেগাল",
  "country_of_birth_option_CS": "সার্বিয়া এবং মন্টিনিগ্রো",
  "country_of_birth_option_SC": "Seychelles.",
  "country_of_birth_option_SL": "সিয়েরা লিওন",
  "country_of_birth_option_SG": "সিঙ্গাপুর",
  "country_of_birth_option_SK": "স্লোভাকিয়া",
  "country_of_birth_option_SI": "স্লোভেনিয়া",
  "country_of_birth_option_SB": "সলোমান দ্বীপপুঞ্জ",
  "country_of_birth_option_SO": "সোমালিয়া",
  "country_of_birth_option_ZA": "দক্ষিন আফ্রিকা",
  "country_of_birth_option_GS": "দক্ষিণ জর্জিয়া এবং সাউথ স্যান্ডউইচ দ্বীপপুঞ্জ",
  "country_of_birth_option_ES": "স্পেন",
  "country_of_birth_option_LK": "শ্রীলংকা",
  "country_of_birth_option_SD": "সুদান",
  "country_of_birth_option_SR": "সুরিনাম",
  "country_of_birth_option_SJ": "Svalbard এবং জন মায়েন",
  "country_of_birth_option_SZ": "সোয়াজিল্যান্ড",
  "country_of_birth_option_SE": "সুইডেন",
  "country_of_birth_option_CH": "সুইজারল্যান্ড",
  "country_of_birth_option_SY": "সিরিয় আরব প্রজাতন্ত্র",
  "country_of_birth_option_TW": "তাইওয়ান, চীন প্রদেশ",
  "country_of_birth_option_TJ": "তাজিকিস্তান",
  "country_of_birth_option_TZ": "তানজানিয়া, ইউনাইটেড প্রজাতন্ত্রের",
  "country_of_birth_option_TH": "থাইল্যান্ড",
  "country_of_birth_option_TL": "টিমর-লেস্টে",
  "country_of_birth_option_TG": "যাও",
  "country_of_birth_option_TK": "টোকেলাউ",
  "country_of_birth_option_TO": "টঙ্গা",
  "country_of_birth_option_TT": "ত্রিনিদাদ ও টোবাগো",
  "country_of_birth_option_TN": "তিউনিশিয়া",
  "country_of_birth_option_TR": "তুরস্ক",
  "country_of_birth_option_TM": "তুর্কমেনিস্তান",
  "country_of_birth_option_TC": "টার্কস্ ও কেইকোস দ্বীপপুঞ্জ",
  "country_of_birth_option_TV": "টুভালু",
  "country_of_birth_option_UG": "উগান্ডা",
  "country_of_birth_option_UA": "ইউক্রেন",
  "country_of_birth_option_AE": "সংযুক্ত আরব আমিরাত",
  "country_of_birth_option_GB": "যুক্তরাজ্য",
  "country_of_birth_option_US": "যুক্তরাষ্ট্র",
  "country_of_birth_option_UM": "মার্কিন যুক্তরাষ্ট্র ক্ষুদ্র ও পার্শ্ববর্তী দ্বীপপুঞ্জ",
  "country_of_birth_option_UY": "উরুগুয়ে",
  "country_of_birth_option_UZ": "উজবেকিস্তান",
  "country_of_birth_option_VU": "ভানুয়াতু",
  "country_of_birth_option_VE": "ভেনিজুয়েলা",
  "country_of_birth_option_VN": "ভিয়েতনাম",
  "country_of_birth_option_VG": "ভার্জিন দ্বীপপুঞ্জ, ব্রিটিশ",
  "country_of_birth_option_VI": "ভার্জিন দ্বীপপুঞ্জ, মার্কিন",
  "country_of_birth_option_WF": "ওয়ালিস এবং ফুটুনা",
  "country_of_birth_option_EH": "পশ্চিম সাহারা",
  "country_of_birth_option_YE": "ইয়েমেন",
  "country_of_birth_option_ZM": "জাম্বিয়া",
  "country_of_birth_option_ZW": "জিম্বাবুয়ে",
  "gender_option_female": "মহিলা",
  "gender_option_male": "পুরুষ",
  "gender_option_nonconf": "লিঙ্গ অ conforming",
  "relationship_status_option_single": "একক",
  "relationship_status_option_domestic_partner": "পারিবারিক অংশীদার",
  "relationship_status_option_common_law": "সাধারন আইন",
  "relationship_status_option_emancipated_minor": "মুক্তিযোদ্ধা minal.",
  "relationship_status_option_married": "বিবাহিত",
  "relationship_status_option_divorced": "তালাকপ্রাপ্ত",
  "relationship_status_option_separated": "পৃথক",
  "relationship_status_option_widowed": "বিধবা",
  "housing_option_own": "নিজস্ব",
  "housing_option_room_in_apartment": "অ্যাপার্টমেন্ট রুম",
  "housing_option_friends_or_family": "বন্ধু বা পরিবার",
  "housing_option_regular_rent": "নিয়মিত ভাড়া",
  "housing_option_subsidized_rent": "ভর্তুকি ভাড়া",
  "housing_option_shelter": "আশ্রয়",
  "housing_option_homeless": "গৃহহীন",
  "employment_option_full_time": "পূর্ণ সময়",
  "employment_option_part_time": "খন্ডকালীন",
  "employment_option_unemployed": "বেকার",
  "education_option_no_high_school": "কোন উচ্চ বিদ্যালয়",
  "education_option_high_school_diploma": "উচ্চ বিদ্যালয় ডিপ্লোমা",
  "education_option_ged": "জিডি",
  "education_option_associate_or_bachelo": "সহযোগী বা স্নাতক ডিগ্রী",
  "education_option_post_graduate": "স্নাতকোত্তর গবেষণা",
  "ethnicity_option_two_or_more_races": "দুই বা তার বেশি রেস",
  "ethnicity_option_black": "কালো (অ হিস্পানিক)",
  "ethnicity_option_white": "হোয়াইট (অ হিস্পানিক)",
  "ethnicity_option_hispanic_or_latino": "হিস্পানিক বা ল্যাটিনো",
  "ethnicity_option_asian_or_pacific": "এশিয়ান বা প্রশান্ত মহাসাগরীয়",
  "ethnicity_option_american_indian_or_alaskan": "আমেরিকান ভারতীয় বা আলাস্কান",
  "ethnicity_option_other": "অন্যান্য",
  "snap_benefits": "সম্পূরক পুষ্টি সহায়তা প্রোগ্রাম",
  "wic_benefits": "নারী, শিশু, এবং শিশুদের জন্য সম্পূরক পুষ্টি প্রোগ্রাম",
  "tanf_benefits": "দরিদ্র পরিবারের জন্য অস্থায়ী সহায়তা",
  "medicaid_benefits": "কম আয় সঙ্গে মানুষের জন্য পাবলিক স্বাস্থ্য বীমা",
  "ssi_benefits": "সম্পূরক নিরাপত্তা আয় প্রোগ্রাম",
  "free_reduced_meals": "বিনামূল্যে বা কম খাবার প্রোগ্রাম",
  "tefap_form": "Tefap সার্টিফিকেশন",
  "tefap_form_expired": "আপনার TEFAP প্রত্যয়ন মেয়াদ শেষ হয়ে গেছে",
  "tefap_form_usda_title": "ইউএসডিএ বৈষম্যহীন বিবৃতি",
  "tefap_form_usda_subheader": "নিম্নলিখিত সচেতন করা হবে",
  "tefap_form_usda_body": "<p>In accordance with Federal civil rights law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, the USDA, its Agencies, offices, and employees, and institutions participating in or administering USDA programs are prohibited from discriminating based on race, color, national origin, religion, sex, disability, age, marital status, family/parental status, income derived from a public assistance program, political beliefs, or reprisal or retaliation for prior civil rights activity, in any program or activity conducted or funded by USDA (not all bases apply to all programs). Remedies and complaint filing deadlines vary by program or incident.</p><p>Persons with disabilities who require alternative means of communication for program information (e.g., Braille, large print, audiotape, American Sign Language, etc.) should contact the State or local Agency that administers the program or contact USDA through the Telecommunications Relay Service at 711 (voice and TTY). Additionally, program information may be made available in languages other than English.</p><p>To file a program discrimination complaint, complete the USDA Program Discrimination Complaint Form, AD-3027, found online at <a href=\"https://www.usda.gov/oascr/how-to-file-a-program-discrimination-complaint\">How to File a Program Discrimination Complaint</a> and at any USDA office or write a letter addressed to USDA and provide in the letter all of the information requested in the form. To request a copy of the complaint form, call (866) 632-9992. Submit your completed form or letter to USDA by:</p><p>(1) mail: U.S. Department of Agriculture, Office of the Assistant Secretary for Civil Rights, 1400 Independence Avenue, SW, Mail Stop 9410, Washington, D.C. 20250-9410;</p><p>(2) fax: (202) 690-7442; or</p><p>(3) email: <a href=\"mailto:program.intake@usda.gov\">program.intake@usda.gov</a>.</p><p>USDA is an equal opportunity provider, employer, and lender.</p>",
  "app_button_next": "পরবর্তী",
  "app_button_back": "পেছনে",
  "app_button_submit": "জমা দিন",
  "app_button_close": "বন্ধ",
  "app_button_done": "সম্পন্ন",
  "form_required": "প্রয়োজন *",
  "benefits": "সুবিধা প্রোগ্রাম",
  "benefits_extra": "বেনিফিট প্রোগ্রাম সম্পর্কে বিস্তারিত",
  "help_and_support": "আমরা সাহায্য করতে এখানে আছি",
  "help_and_support_extra": "প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী এবং যোগাযোগের তথ্য",
  "frequently_asked_questions": "সচরাচর জিজ্ঞাস্য",
  "contact_support": "প্রচুর সমর্থন যোগাযোগ করুন",
  "optional_details": "ঐচ্ছিক বিবরণ",
  "address_street_1": "ঠিকানা",
  "address_street_2": "Apt.",
  "city": "শহর",
  "state": "রাষ্ট্র",
  "zipcode": "জিপকোড",
  "additional_optional_details": "অতিরিক্ত তথ্য",
  "gender": "লিঙ্গ",
  "relationship_status": "সম্পর্ক",
  "ethnicity": "জাতিতা",
  "country_of_birth": "জন্মভূমি",
  "employment": "কর্মসংস্থান",
  "highest_education_obtained": "শিক্ষা",
  "food_preferences": "খাদ্য পছন্দ",
  "housing_details": "হাউজিংয়ের বিবরণ",
  "housing_status": "হাউজিং স্ট্যাটাস",
  "special_circumstances": "বিশেষ পরিস্থিতিতে",
  "needs_assistance": "আমি pantries এ সহায়তা প্রয়োজন",
  "dont_need_assistance": "আমি pantries এ সহায়তা প্রয়োজন হয় না",
  "aiq_validation_error_min_adult_family_members": "পরিবারের প্রাপ্তবয়স্ক সদস্যদের সংখ্যা ০ এর বেশি হতে হবে",
  "aiq_validation_error_max_adult_family_members": "পরিবারের প্রাপ্তবয়স্ক সদস্যদের সংখ্যা ১০ জনের বেশি হতে পারবে না",
  "aiq_validation_error_min_child_family_members": "পরিবারের শিশু সদস্যদের সংখ্যা ০ এর বেশি হতে হবে",
  "aiq_validation_error_max_child_family_members": "পরিবারের শিশু সদস্য সংখ্যা ১০ জনের বেশি হতে পারবে না",
  "aiq_validation_error_min_senior_family_members": "পরিবারের বয়স্ক সদস্যদের সংখ্যা ০ এর বেশি হতে হবে",
  "aiq_validation_error_max_senior_family_members": "পরিবারের বয়স্ক সদস্যদের সংখ্যা ১০ জনের বেশি হতে পারবে না",
  "aiq_validation_error_required_emergency_contact": "জরুরী যোগাযোগের তথ্য প্রয়োজন",
  "aiq_validation_error_required_pick_up_name": "পিক আপ রিপ্রেজেন্টেটিভের নামের তথ্য প্রয়োজন",
  "aiq_validation_error_required_birth_date": "জন্ম তারিখ তথ্য প্রয়োজন",
  "aiq_validation_error_regex_zip_code": "জিপ কোড সংখ্যাসূচক হতে হবে",
  "aiq_validation_error_required_first_name": "প্রথম নাম প্রয়োজন",
  "aiq_validation_error_required_last_name": "পদবি প্রয়োজন",
  "aiq_validation_error_min_baby_supplies": "শিশুর সরবরাহ অবশ্যই 0-এর বেশি হতে হবে",
  "aiq_validation_error_max_baby_supplies": "শিশুর সরবরাহ 10 এর বেশি হতে পারে না",
  "dietary_preferences_option_lactose": "ল্যাকটোজ অসহিষ্ণুতা",
  "dietary_preferences_option_gluten": "গ্লুটেন অসহিষ্ণুতা",
  "dietary_preferences_option_kosher": "কোশার",
  "dietary_preferences_option_halal": "হালাল",
  "dietary_preferences_option_dairy_free": "বিনামূল্যে দুগ্ধ",
  "dietary_preferences_option_vegetarian": "নিরামিষাশী",
  "dietary_preferences_option_vegan": "Vegan.",
  "dietary_preferences_option_fodmap": "Fodmap.",
  "dietary_preferences_option_nut_allergy": "গাছ বাদাম এবং চিনাবাদাম এলার্জি",
  "dietary_preferences_option_fish_allergy": "মাছ এবং শেলফিশ এলার্জি",
  "dietary_preferences_option_none": "কোন পছন্দ নেই",
  "tefap_additional_info_requested": "অতিরিক্ত তথ্য অনুরোধ",
  "tefap_zipcode_correct": "আপনার জিপ কোড সঠিক?",
  "tefap_address_correct": "আপনার ঠিকানা সঠিক?",
  "tefap_participate_in_programs": "আপনার পরিবারের কেউ নিম্নলিখিত কোন প্রোগ্রামে অংশগ্রহণ করে?",
  "tefap_check_all_that_apply": "প্রযোজ্য সব নির্বাচন করুন. যদি না হয়, আরও বিকল্পের জন্য পরবর্তী ক্লিক করুন।",
  "tefap_household_numbers_correct": "আপনার পরিবারের মানুষের সংখ্যা সঠিক?",
  "tefap_household_dont_include_yourself": "এই পর্দায় নিজেকে অন্তর্ভুক্ত করবেন না দয়া করে. TEFAP-এর জন্য শুধুমাত্র আপনার পরিবারের মোট আকার প্রয়োজন, কিন্তু Plentiful আপনার পূর্বে দেওয়া তথ্য প্রদর্শন করছে।",
  "tefap_income_at_or_below_question": "আপনার আয় বা নীচে আপনার আয়",
  "tefap_for_household_size": "আপনার পরিবারের জন্য",
  "tefap_retake_attestation": "আপনি কি সাক্ষ্য দিতে চান?",
  "tefap_attestation_completed": "আপনি সফলভাবে TEFAP প্রত্যয়ন ফর্ম সম্পন্ন করেছেন।",
  "tefap_thank_you": "ধন্যবাদ!",
  "tefap_is_recorded": "আপনার TEFAP প্রত্যয়ন রেকর্ড করা হয়েছে। আপনি আপনার প্রোফাইলে এটি পুনরুদ্ধার করতে পারেন।",
  "tefap_sign_below": "আপনার নাম (ঐচ্ছিক)",
  "tefap_legal_signing": "নীচের সাইন ইন করে, আমি ঘোষণা করি যে সমস্ত উত্স থেকে আমার আয়গুলি আমার পরিবারের মতো একই সংখ্যক লোকের সাথে তালিকাভুক্ত আয় অতিক্রম করে না বা আমার পরিবার এই ফর্মটিতে আমি যে প্রোগ্রামটি চেক করেছি তার মধ্যে অংশগ্রহণ করে। আমি বুঝি যে এই রেকর্ডগুলি এই বন্টন সাইটে আক্রমনে অনুষ্ঠিত হবে তবে তাদের অনুরোধের জন্য নিউইয়র্ক স্টেট অফিসের নিউইয়র্ক স্টেট ডিপার্টমেন্ট অফিসে প্রকাশ করা যেতে পারে।",
  "tefap_retake": "Retake.",
  "program_complete_now": "এখন সম্পূর্ণ করুন",
  "program_complete_later": "পরে সম্পূর্ণ",
  "reservation_confirmed": "নিশ্চিত পরিদর্শন করুন",
  "tefap_reservation_confirmed": "আপনার দর্শন নিশ্চিত করা হয়েছে!",
  "pre_registration_confirmed": "নিশ্চিত পরিদর্শন করুন",
  "your_upcoming_reservation": "আপনার আসন্ন ভিজিট",
  "your_upcoming_pre_registration": "আপনার আসন্ন ভিজিট",
  "tefap_attestation_needed": "এই pantry আপনার TEFAP প্রত্যয়ন অনুরোধ করা হয়।",
  "tefap_attestation_complete_now": "এখন এটি সম্পূর্ণ করুন এবং আপনার পরবর্তী প্যান্ট্রি দর্শন সময়ে সময় সংরক্ষণ করুন।",
  "tefap_description": "দ্য ইমার্জেন্সি ফুড অ্যাসিসট্যান্স প্রোগ্রাম (TEFAP) এর মাধ্যমে, USDA আপনার স্থানীয় সম্প্রদায়কে খাদ্য সহায়তা প্রদান করে, এটি আপনার জন্য স্যুপ রান্নাঘর এবং খাবারের প্যান্ট্রির মতো কমিউনিটি এজেন্সির মাধ্যমে উপলব্ধ করে।",
  "tefap_what_is_tefap": "Tefap কি?",
  "tefap_confirm_share_with_pantry": "আপনি এই pantry সঙ্গে নিম্নলিখিত তথ্য শেয়ার করতে চান দয়া করে নিশ্চিত করুন।",
  "tefap_thanks_for_sharing": "Pantry দ্বারা অনুরোধ অতিরিক্ত তথ্য প্রদানের জন্য আপনাকে ধন্যবাদ!",
  "tefap_continue_make_reservation": "একটি পরিদর্শন সময়সূচী অবিরত",
  "tefap_pantry_is_requesting": "এই pantry আপনার অনুরোধ করা হয়",
  "tefap_missing_information": "অনুপস্থিত তথ্য",
  "tefap_pantry_will_ask": "এই তথ্যটি এখনই যোগ করতে 'পরবর্তী' ক্লিক করুন। যদি আপনি এটি এড়িয়ে যান, তাহলে প্যান্ট্রি আপনার পরবর্তী ভিজিটের সময় এটি চাইবে।",
  "tefap_submission_pending": "প্যান্ট্রিতে আপনার উত্তর জমা দেওয়া হচ্ছে...",
  "cancel_edit": "সম্পাদনা বাতিল করুন",
  "edit": "সম্পাদনা করুন",
  "select": "নির্বাচন করুন",
  "can_prepare_food": "খাদ্য প্রস্তুত করতে পারেন",
  "cannot_prepare_food": "খাদ্য প্রস্তুত করতে পারবেন না",
  "pantry_details_prompt_title": "{{programName}} প্রয়োজন",
  "pantry_details_prompt_without_visit_label": "এই প্যান্ট্রিটি নিবন্ধনের জন্য {{programName}} ব্যবহার করছে। আপনাকে প্যান্ট্রিতে পৌঁছানোর সময় অতিরিক্ত প্রশ্নের উত্তর দিতে হবে।",
  "pantry_details_prompt_visit_label": "এই প্যান্ট্রিটি নিবন্ধনের জন্য {{programName}} ব্যবহার করছে। অনলাইনে এই প্রশ্নগুলির উত্তর দিয়ে আপনার পরবর্তী সফরে সময় সাশ্রয় করুন।",
  "state_program_attestation_cannot_complete": "আমরা দুঃখিত, কিন্তু এই মুহূর্তে আমরা আপনার প্রত্যয়ন সম্পূর্ণ করতে অক্ষম। আপনি পরে আবার চেষ্টা করতে পারেন, সহায়তার সাথে যোগাযোগ করতে পারেন, অথবা প্যান্ট্রিতে পৌঁছানোর সময় এটি সম্পূর্ণ করতে পারেন।",
  "state_program_attestation_submitted": "{{programName}} প্রত্যয়ন সম্পূর্ণ করার জন্য ধন্যবাদ! আপনার উত্তরগুলি সফলভাবে প্যান্ট্রিতে জমা দেওয়া হয়েছে। এটি {{programName}} প্রশ্নের সমাপ্তি, এবং অন্য যেকোনো অতিরিক্ত প্রম্পট অন্যান্য Plentiful প্রোগ্রাম থেকে আসে।",
  "state_program_cancel_confirmation": "আপনি কি নিশ্চিত যে আপনি {{programName}} এর জন্য আপনার প্রত্যয়ন বাতিল করতে চান? প্যান্ট্রি পরিদর্শন করার সময় আপনাকে এখনও এই প্রশ্নগুলির উত্তর দিতে হতে পারে।",
  "state_program_cancel_attestation": "প্রত্যয়ন বাতিল করুন",
  "state_program_resume_attestation": "প্রত্যয়ন পুনরায় শুরু করুন",
  "tefap_no_submit": "না, জমা দিন",
  "tefap_yes_retake": "হ্যাঁ, retake.",
  "tefap_expires": "মেয়াদ শেষ",
  "tefap_incomplete": "অসম্পূর্ণ, আপনার পরবর্তী প্যান্ট্রি পরিদর্শনে সময় বাঁচাতে এখনই সম্পূর্ণ করুন",
  "tefap_none": "কেউ না",
  "tefap_benefit_programs_select": "নিম্নলিখিত প্রোগ্রামে আপনার তালিকাভুক্তি নির্বাচন করুন",
  "tefap_pantry_requests_info": "এই প্যান্ট্রি আপনার আসন্ন দর্শন জন্য অতিরিক্ত তথ্য অনুরোধ করা হয়।",
  "tefap_eligible": "আপনি যোগ্য",
  "tefap_not_eligible": "আপনি যোগ্য নন",
  "tefap_receive_product": "TEFAP পণ্য পেতে",
  "tefap_eligible_program": "আপনি নিম্নলিখিত প্রোগ্রামে অংশগ্রহণ",
  "tefap_eligible_programs": "আপনি নিম্নলিখিত প্রোগ্রামে অংশগ্রহণ",
  "tefap_not_eligible_program": "আপনি কোন প্রোগ্রামে অংশগ্রহণ করবেন না",
  "tefap_household_income": "আপনার পরিবারের আয় জন্য",
  "tefap_info_changed": "আপনার TEFAP যোগ্যতা তথ্য আছে (বেনিফিট প্রোগ্রাম, পরিবারের আকার এবং / অথবা আয়তে অংশগ্রহণ) সম্প্রতি পরিবর্তিত হয়েছে?",
  "tefap_still_get_food": "আপনি এখনও প্যান্ট্রি থেকে নন-TEFAP খাবার পেতে পারেন।",
  "tefap_form_checking_here": "এখানে চেক করে, আপনি যে নিম্নলিখিতটি সত্য তা সত্য বলে মনে করেন:",
  "tefap_form_checking_1": "1. প্রাপকের নাম, ঠিকানা এবং উপরে দেওয়া পরিবারের আকার সঠিক।",
  "tefap_form_checking_2_CO": "2. প্রাপক কলোরাডোর মধ্যে থাকেন (কোনও ন্যূনতম দৈর্ঘ্যের প্রয়োজন নেই)।",
  "tefap_form_checking_2_NY": "2. প্রাপক নিউ ইয়র্ক স্টেটের মধ্যে বসবাস করে (কোন ন্যূনতম দৈর্ঘ্য প্রয়োজন নেই)।",
  "tefap_form_checking_3": "3. প্রাপক উপরে TEFAP যোগ্যতা নির্দেশিকা বিকল্প 2 এবং / অথবা বিকল্প 2 পূরণ করুন।",
  "tefap_form_checking_4": "4. এই খাদ্য প্রাপকের বাড়ির ব্যবহারের জন্য শুধুমাত্র, এবং বিক্রি করা হবে না, ব্যবসা বা বর্জিত করা হবে না।",
  "tefap_form_checking_5_1": "5. প্রাপক তাদের নাগরিক অধিকার সচেতন হিসাবে বর্ণনা করা হয়",
  "tefap_form_checking_5_2": "ইউএসডিএ nondiscrimination বিবৃতি।",
  "tefap_out_of_state": "আপনি একটি ভিন্ন রাজ্যে বাস",
  "and": "এবং",
  "or": "অথবা",
  "exceeds": "নিচে না",
  "not_exceeds": "অতিক্রম করেনি",
  "people": "মানুষ",
  "person": "ব্যক্তি",
  "because": "কারণ",
  "custom_field_first_name": "নামের প্রথম অংশ",
  "custom_field_last_name": "নামের শেষাংশ",
  "custom_field_contact_info": "যোগাযোগের তথ্য",
  "custom_field_birth_date": "জন্মদিন",
  "custom_field_zip_code": "জিপ কোড",
  "custom_field_household_size": "Houshold আকার",
  "custom_field_food_pickup": "পিকআপ প্রতিনিধি",
  "custom_field_emergency_contact": "জরুরী যোগাযোগ",
  "custom_field_address": "ঠিকানা",
  "custom_field_needs_assistance": "বিশেষ পরিস্থিতিতে (সহায়তা প্রয়োজন)",
  "custom_field_benefits_programs": "সুবিধা প্রোগ্রাম",
  "custom_field_tefap_income_eligibility": "Tefap আয় যোগ্যতা",
  "custom_field_relationship_status": "সম্পর্ক",
  "custom_field_ethnicity": "জাতিতা",
  "custom_field_education": "সর্বোচ্চ শিক্ষা প্রাপ্ত",
  "custom_field_dietary_preferences": "খাদ্যতালিকাগত পছন্দ",
  "custom_field_gender": "লিঙ্গ",
  "custom_field_country_of_birth": "জন্মভূমি",
  "custom_field_employment": "কর্মসংস্থান",
  "custom_field_food_preparation": "খাদ্য প্রস্তুত করতে পারেন",
  "custom_field_housing": "হাউজিং স্ট্যাটাস",
  "search": "অনুসন্ধান (প্যান্ট্রির নাম, জিপ, শহর, রাজ্য)",
  "all": "সব",
  "pantry_filter_program_type": "প্রোগ্রামের ধরন",
  "pantry_filter_program_type_non-food": "খাদ্য নাই",
  "pantry_filter_program_type_foodpantry": "ফুড প্যান্ট্রি (ফ্রি মুদি)",
  "pantry_filter_program_type_soupkitchen": "স্যুপ রান্নাঘর (বিনামূল্যে গরম খাবার)",
  "pantry_filter_status": "স্ট্যাটাস",
  "pantry_filter_status_all": "সব",
  "pantry_filter_status_opennow": "এখন খুলুন",
  "pantry_filter_status_opentoday": "আজ খুলুন",
  "pantry_filter_status_openthisweek": "এই সপ্তাহে খুলুন",
  "pantry_filter_status_other": "অন্যান্য",
  "pantry_filter_pantry_type": "প্যান্ট্রি টাইপ",
  "pantry_filter_pantry_type_plentifulpantry": "প্রচুর প্যান্ট্রি",
  "pantry_filter_pantry_type_verifiedpartnerpantry": "যাচাইকৃত অংশীদার প্যান্ট্রি",
  "pantry_filter_pantry_type_unverifiedpartnerpantry": "অযাচাইকৃত পার্টনার প্যান্ট্রি",
  "search_no_results_found": "কোন ফলাফল পাওয়া যায়নি",
  "search_no_pantries_match": "কোন প্যান্ট্রি \"{query}\" এর সাথে মেলে না",
  "search_try_searching_by": "দ্বারা অনুসন্ধান করার চেষ্টা করুন:",
  "search_suggestion_city": "শহরের নাম (যেমন, \"ব্রুকলিন\")",
  "search_suggestion_city_accessibility": "শহরের নাম, উদাহরণস্বরূপ, ব্রুকলিন",
  "search_suggestion_zipcode": "জিপ কোড (যেমন, \"10001\")",
  "search_suggestion_zipcode_accessibility": "জিপ কোড, উদাহরণস্বরূপ, 10001",
  "search_suggestion_pantry_name": "প্যান্ট্রি নাম",
  "search_suggestion_street_address": "রাস্তার ঠিকানা",
  "search_accessibility_no_results": "{query} এর জন্য কোন ফলাফল পাওয়া যায়নি। শহরের নাম, জিপ কোড, প্যান্ট্রি নাম বা রাস্তার ঠিকানা দ্বারা অনুসন্ধান করার চেষ্টা করুন।",
  "search_accessibility_no_results_generic": "কোন ফলাফল পাওয়া যায়নি। শহরের নাম, জিপ কোড, প্যান্ট্রি নাম বা রাস্তার ঠিকানা দ্বারা অনুসন্ধান করার চেষ্টা করুন।",
  "search_accessibility_no_results_sites": "{query} এর জন্য কোন ফলাফল পাওয়া যায়নি। প্যান্ট্রি নাম বা শহর দ্বারা অনুসন্ধান করার চেষ্টা করুন।",
  "search_accessibility_no_results_sites_generic": "কোন ফলাফল পাওয়া যায়নি। প্যান্ট্রি নাম বা শহর দ্বারা অনুসন্ধান করার চেষ্টা করুন।",
  "search_error_unable_to_display": "অনুসন্ধান ফলাফল প্রদর্শন করতে অক্ষম",
  "search_error_occurred": "আপনার অনুসন্ধান ফলাফল প্রদর্শন করার সময় একটি ত্রুটি ঘটেছে। অনুগ্রহ করে আবার অনুসন্ধান করার চেষ্টা করুন।",
  "search_results_truncated": "সেরা ফলাফলগুলো দেখানো হচ্ছে। আপনি যা খুঁজছেন তা না পেলে ভিন্নভাবে অনুসন্ধান করে দেখুন।",
  "accessibility_phone": "ফোন: {phone}",
  "accessibility_email": "ইমেল: {email}",
  "accessibility_website": "ওয়েবসাইট: {website}",
  "pantry_filter_service_type": "সেবার ধরণ",
  "pantry_filter_service_type_line": "লাইন-ভিত্তিক",
  "pantry_filter_service_type_pre-registration": "প্রাক-নিবন্ধন",
  "pantry_filter_service_type_qr-code": "QR কোড চেক-ইন",
  "pantry_filter_service_type_reservation": "রিজার্ভেশন",
  "program_type_benefit_enrollment": "সুবিধা তালিকাভুক্তি",
  "program_type_emergency_services": "জরুরী সেবা",
  "program_type_non_plentiful_pantry": "অ-পূণ্য প্যান্ট্রি",
  "program_type_other_services": "অন্যান্য সেবা",
  "program_type_plentiful_pantry": "প্রচুর প্যান্ট্রি",
  "program_type_shelter": "আশ্রয়",
  "program_type_soup_kitchen": "সুপ রান্নাঘর",
  "service_restriction_none": "কোন বাধা নেই",
  "service_restriction_seniors": "শুধুমাত্র সিনিয়ররা",
  "service_restriction_families_with_children": "শুধুমাত্র বাচ্চাদের সাথে পরিবার",
  "service_restriction_new_clients": "শুধুমাত্র নতুন ক্লায়েন্ট",
  "service_restriction_existing_clients": "শুধুমাত্র বিদ্যমান ক্লায়েন্ট",
  "filter_by_category": "বিভাগ দ্বারা ফিল্টার",
  "opted_out": "দেখে মনে হচ্ছে আপনার ফোন নম্বরটি এসএমএস থেকে বেছে নিয়েছে যাতে আমরা আপনাকে আপনার লগইন কোডটি প্রেরণ করতে পারি না। দয়া করে START থেকে 726879 টেক্সট করে ফিরে যান এবং তারপরে আবার চেষ্টা করুন",
  "miles_away_singular": "%s মাইল দূরে",
  "miles_away_plural": "%s মাইল দূরে",
  "today": "আজ",
  "address_autocomplete_placeholder": "পরামর্শ দেখতে টাইপ করা শুরু করুন",
  "push_notification_permissions_denied": "পুশ বিজ্ঞপ্তির জন্য অনুমতি দেওয়া হয়নি। অনুগ্রহ করে আপনার সিস্টেম সেটিংস খুলুন এবং পুশ বিজ্ঞপ্তি সক্ষম করুন৷",
  "push_notification_setup_error": "পুশ বিজ্ঞপ্তি সেট আপ করার সময় একটি ত্রুটি ছিল৷",
  "push_notification_alternate_notifications": "আপনি এখনও SMS বা ইমেলের মাধ্যমে বিজ্ঞপ্তি পাবেন।",
  "loading_message": "আপনার কাছাকাছি খাবারের দোকান খুঁজে পাওয়া",
  "location_services_no_access": "আপনার ডিভাইসের অবস্থানে প্রচুর অ্যাক্সেস আছে বলে মনে হচ্ছে না। অনুগ্রহ করে আপনার ব্রাউজার বা ডিভাইস সেটিংসে Plentiful-এর জন্য অবস্থান পরিষেবাগুলি সক্ষম করুন৷",
  "error_screen_header": "ওহো! কিছু একটা সমস্যা হয়েছে।",
  "error_screen_message": "আমরা একটি অপ্রত্যাশিত সমস্যার সম্মুখীন হয়েছি। আপনি অ্যাপটি পুনরায় চালু করার চেষ্টা করতে পারেন অথবা সহায়তার সাথে যোগাযোগ করতে পারেন।",
  "update_available_header": "আপডেট উপলব্ধ",
  "update_available_message": "সর্বশেষ সংস্করণ লোড করতে পুনরায় চালু করুন।",
  "restart_app": "অ্যাপ রিস্টার্ট করুন",
  "email_support": "ইমেল সমর্থন",
  "map_zoom_to_see_all": "সমস্ত অবস্থান দেখতে জুম করুন",
  "program_eligible": "আপনি {{program}} এর জন্য যোগ্য।",
  "program_ineligible": "আপনি {{program}} প্রোগ্রামের জন্য অযোগ্য: {{reason}}",
  "program_not_applicable": "আপনি {{program}} সম্পন্ন করেছেন।",
  "program_completed": "আপনি সমস্ত {{program}} প্রশ্ন সম্পন্ন করেছেন।",
  "program_unknown_eligibility": "ফর্মটি পূরণ করার জন্য ধন্যবাদ। আপনি পৌঁছানোর পর পরিষেবা প্রদানকারী আপনার যোগ্যতা নির্ধারণ করবেন।",
  "site_map_error_title": "কিছু ভুল হয়েছে",
  "site_map_error_message": "আমরা মানচিত্রটি লোড করতে পারিনি। অনুগ্রহ করে আবার চেষ্টা করুন।",
  "site_map_load_error_title": "সাইট লোড করা যায়নি",
  "site_map_load_error_message": "এই এলাকা লোড করতে সমস্যা হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
  "site_map_retry": "আবার চেষ্টা করুন",
  "site_list_search_placeholder": "Search pantry name, ZIP, city",
  "site_list_result_count": "{{count}}টি স্থান",
  "site_list_result_count_one": "{{count}}টি স্থান",
  "site_list_result_count_zero": "কোনো স্থান পাওয়া যায়নি",
  "site_list_today": "Today",
  "site_list_tomorrow": "Tomorrow",
  "site_list_status_open_until": "Open now until {{time}}",
  "site_list_status_open_now": "এখন খোলা",
  "site_list_status_closed_next_open": "Closed now · next open {{day}} {{time}}",
  "site_list_status_no_upcoming": "No upcoming services",
  "site_list_status_more_available": "আরও সময় থাকতে পারে · খাদ্য ভাঁড়ারঘরের সাথে যোগাযোগ করুন",
  "site_list_booking_walkin": "Walk in",
  "site_list_booking_reservation": "Reservation",
  "site_list_booking_preregistration": "Pre-registration",
  "site_list_booking_unknown": "অজানা",
  "site_list_more_times": "+ more times available",
  "site_list_default_event_name": "Food Distribution",
  "site_list_unconfirmed_title": "Hours not confirmed",
  "site_list_unconfirmed_body": "We list this place from a partner directory but don't have its current times. Call before you go.",
  "site_list_timezone_note": "সময় {{zone}} অনুযায়ী দেখানো হয়েছে",
  "site_details_upcoming_events_heading": "আসন্ন সেবা",
  "site_details_reserve_cta": "একটি সময় সংরক্ষণ করুন",
  "site_details_plan_visit_cta": "আপনার ভ্রমণের পরিকল্পনা করুন",
  "site_details_no_upcoming_events": "কোনো আসন্ন পরিষেবা নেই",
  "site_details_timezone_note": "সময় {{zone}} অনুযায়ী দেখানো হয়েছে",
  "site_details_more_windows": "+ আরও সময় উপলব্ধ",
  "site_details_event_name_fallback": "বিতরণ",
  "site_details_slot_picker_no_times": "কোনো সময় উপলব্ধ নেই",
  "site_details_slot_full": "পূর্ণ",
  "site_details_availability_as_of": "{{time}} অনুযায়ী প্রাপ্যতা",
  "site_details_availability_error": "আমরা সময়গুলো লোড করতে পারিনি। অনুগ্রহ করে আবার চেষ্টা করুন।"
}
